import {translation as enUsLanguageSelectorTranslation} from './en-US';
import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = enUsLanguageSelectorTranslation;
